import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { redeemSessionToken } from "../services/apiService";
import analyticsService from "../services/analyticsService";

// Canal A — reprise de session via le lien email : /sessions/:sessionToken/resume
// Au chargement, on échange le token opaque contre des tokens OAuth2 (ou un récap
// de session terminée), puis on bascule vers la page de suivi.
export default function SessionLinkComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { sessionToken } = useParams();
  const [error, setError] = useState("");
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const redeem = async () => {
      if (!sessionToken) {
        navigate("/error", {
          state: { errorText: t("resumeSession.errors.invalidLink") },
        });
        return;
      }

      analyticsService.pushPageView("session_link_redeem");

      try {
        const data = await redeemSessionToken(sessionToken);

        if (data.accessToken) {
          sessionStorage.setItem("accessToken", data.accessToken);
        }
        if (data.refreshToken) {
          sessionStorage.setItem("refreshToken", data.refreshToken);
        }

        analyticsService.pushEvent("session_link_redeem_success", {
          finished: Boolean(data.finishedTransaction),
        });

        navigate("/start-charging", {
          replace: true,
          state: {
            accessToken: data.accessToken,
            finishedTransaction: data.finishedTransaction || null,
          },
        });
      } catch (err) {
        analyticsService.pushEvent("session_link_redeem_failed", {
          status: err?.status,
        });
        setError(
          err?.status === 404
            ? t("resumeSession.errors.invalidLink")
            : t("resumeSession.errors.generic")
        );
      }
    };

    redeem();
  }, [sessionToken, navigate, t]);

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-4 pt-36">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          <strong className="font-bold">{t("errorTitle")}</strong>
          <span className="block sm:inline"> {error}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center space-y-8">
      <div className="flex space-x-1">
        {[...Array(6)].map((_, i) => (
          <span
            key={i}
            className="w-2 h-2 rounded-full bg-indigo-600 animate-bounce"
            style={{ animationDelay: `${i * 0.1}s` }}
          />
        ))}
      </div>
      <p className="text-black font-semibold text-lg">{t("loading")}</p>
    </div>
  );
}
